import SocketEvent from "./abstract/SocketEvent"
import {
    GetPatientMedicationInformationSpecification,
    OnMedicationMatrixScannedEventKey,
    OnMedicationMatrixScannedEventPayload
} from "pokal_api"
import { AppDispatch } from "../redux/store/store"
import { dispatchThunk } from "../redux/thunk/thunkify"
import { showNotification } from "../redux/Notification"

const OnMedicationMatrixScannedEvent: SocketEvent<OnMedicationMatrixScannedEventPayload> =
    new SocketEvent(
        OnMedicationMatrixScannedEventKey,
        (args, input, dispatch: AppDispatch) => {
            dispatchThunk(
                dispatch,
                GetPatientMedicationInformationSpecification,
                { patient: args.patient }
            )
            showNotification(
                dispatch,
                "Neuer Medikationsplan",
                `Für Patient:in ${args.patientName} wurde ein neuer Medikationsplan gescanned.`
            )
        }
    )

export default OnMedicationMatrixScannedEvent
